import userPermissionService from '../services/user_permission'

// State
export const state = {
  userList: [],
  userPagination: [],
  apiErrors: {},
  userData: {},
  linkedRecords: {},
}

// getters
export const getters = {
  fetchUserList: state => state.userList,
  fetchUserPaginationMeta: state => state.userPagination,
  fetchApiError: state => state.apiErrors,
  getUserData: state => state.userData,
}

export const mutations = {
  FETCH_USER_DATA (state, data) {
    state.userList = data.data
    state.userPagination = data.meta
  },

  API_ERROR (state, data) {
    state.apiErrors = data.errors
  },
  REMOVE_API_ERROR (state) {
    state.apiErrors = {}
  },

  SET_USER_DATA (state, data) {
    state.userData = data.data.original
  },

  REMOVE_USER_DATA(state) {
      state.userData = {}
  },

    SET_LINKED_RECORDS(state, payload) {
        state.linkedRecords = payload;
    }
}

// actions
export const actions = {
  async fetchUserPermissions({commit}, payload) {
      try {
          const { data } = await userPermissionService.fetchUserPermissions(payload)
          commit('FETCH_USER_DATA', data)
      } catch (e) {
          console.log('Error: ', e)
          throw e
      }
  },

  async bulkDeleteUserPermissions({commit}, payload) {
        try {
            const { data } = await userPermissionService.bulkDeleteUserPermissions(payload)
            return data;
        } catch (e) {
            console.log('Error: ', e)
            throw e
        }
  },

  async createUserPermission({commit}, payload) {
    try {
        const { data } = await userPermissionService.createUserPermission(payload)
        commit('REMOVE_API_ERROR')
        return data;
    } catch (e) {
        if(e.response.status === 422) {
            commit('API_ERROR', e.response.data)
            return
        }
        console.log('Error: ', e)
        throw e
    }
  },
  async detailUserPermission({commit}, payload) {
    try {
        const { data } = await userPermissionService.detailUserPermission(payload.id)
        commit('SET_USER_DATA', data)
    } catch (e) {
        if(e.response.status === 404) {
            commit('API_ERROR', {errors: ['Record not found']})
            return
        }
        throw e
    }
  },
  async updateUserPermission({commit}, payload) {
    try {
        const { data } = await userPermissionService.updateUserPermission(payload)
        commit('REMOVE_API_ERROR')
        return data;
    } catch (e) {
        if(e.response.status === 422) {
            commit('API_ERROR', e.response.data)
            return
        }
        console.log('Error: ', e)
        throw e
    }
  },

  async deleteUserPermission({commit}, id) {
    try {
        await userPermissionService.deleteUserPermission(id)
        commit('REMOVE_USER_DATA');
    } catch (e) {
        if (e.response && e.response.data && e.response.data.message) {
            commit('API_ERROR', { errors: e.response.data.message });
        } else {
            commit('API_ERROR', { errors: 'Unexpected error occurred.' });
        }
        setTimeout(() => {
            commit('REMOVE_API_ERROR')
        }, 1000);
        throw e
    }
  },

    async fetchLinkedRecords({ commit }, userId) {
        try {
            const response = await userPermissionService.fetchLinkedRecords(userId);
            const result = response.data;
            commit('SET_LINKED_RECORDS', result.data);
            return result.data;
        } catch (e) {
            if (e.response?.status === 404) {
                commit('API_ERROR', { errors: ['Record not found'] });
                return;
            }

            commit('API_ERROR', { errors: ['Something went wrong while fetching linked records.'] });
            throw e;
        }
    },

    async assignLinkedRecords({commit}, payload) {
        try {
            const { data } = await userPermissionService.assignLinkedRecords(payload)
            return data;
        } catch (e) {
            console.log('Error: ', e)
            throw e
        }
    },

    async assignMultipleLinkedRecords({commit}, payload) {
        try {
            const { data } = await userPermissionService.assignMultipleLinkedRecords(payload)
            return data;
        } catch (e) {
            console.log('Error: ', e)
            throw e
        }
    },
}
